import { createContext } from 'react'

export const ProductSpecsContext = createContext('')